<script>
import breakpoints from '@/utils/breakpoints.js'
import { DATE_FILTER_OPTIONS } from '@/utils/constants'
import applyDateFilter from '@/mixins/app.js'
import tenant from '@/mixins/tenant.js'
export default {
  mixins: [applyDateFilter, tenant],
  data () {
    return {
      breakpoints,
      dateFilterOptions: DATE_FILTER_OPTIONS,
      authState: 'generateTransactionReport',
      tableFormFilter: {
        date: '',
        startDate: '',
        status: ''
      },
      showVerifyAuthDialog: false,
      selectedTransaction: null,
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      payload: {
        from: '',
        to: '',
        reportFileType: 'pdf'
      }
    }
  },
  props: {
    showReportDialog: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeReportDialog')
    },
    disabledDate (time) {
      return new Date(time).getTime() > new Date().getTime()
    },
    openVerifyAuthDialog () {
      this.showVerifyAuthDialog = true
    },
    closeVerifyAuthDialog () {
      this.showVerifyAuthDialog = false
    },
    async getTransactionReport () {
      this.payload.type = this.selectedTransaction
      this.applyDateFilter(this.tableFormFilter)
      await this.$store
        .dispatch('transactions/getTransactionReport', this.payload)
        .then(() => {
          this.$notify({
            showClose: true,
            title: 'Transaction Report',
            message: 'Transaction Report will be sent to your email',
            position: 'top-right',
            type: 'success'
          })
          this.$emit('closeReportDialog')
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.closeVerifyAuthDialog()
        })
    }
  },
  computed: {
    isDevEnvironment () {
      return process.env.VUE_APP_DEV_INDICATOR === 'true'
    },
    csvLink () {
      return this.$store.state.transactions.reportLink
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '33%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    isCustomDate () {
      return this.tableFormFilter.date === 'custom'
    },
    reportFileTypes () {
      return [
        {
          label: 'PDF',
          value: 'pdf'
        },
        {
          label: 'CSV',
          value: 'csv'
        }
      ]
    }
  },
  components: {
    CloseIcon: () => import('@/assets/v2/icons/CloseIcon.vue'),
    VerifyAuthDialog: () => import('@/components/v2//auth/VerifyAuthDialog')
  }
}
</script>
<template>
  <div>
    <el-dialog
      :visible.sync="showReportDialog"
      :width="modalWidth"
      top="30vh"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      custom-class="custom-scrollable"
      :show-close="false"
    >
      <div class="flex justify-between" id="header">
        <p class="text-lg text-black">Generate Report</p>
        <span class="cursor-pointer" @click="handleClose"
          ><close-icon color="#5D5E68" size="h-5 w-5"
        /></span>
      </div>
      <el-divider class="my-2" />
      <el-form>
        <el-form-item label="Filter by Date">
          <el-select
            v-model="tableFormFilter.date"
            placeholder="Select an option"
            class="border w-full"
          >
            <el-option
              v-for="date in dateFilterOptions"
              :key="date.label"
              :label="date.label"
              :value="date.value"
              >{{ date.label }}</el-option
            >
          </el-select>
        </el-form-item>
        <el-form-item v-if="isCustomDate">
          <el-date-picker
            v-model="tableFormFilter.startDate"
            type="daterange"
            range-separator="-"
            start-placeholder="Start date"
            end-placeholder="End date"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="isDevEnvironment">
          <el-radio-group v-model="payload.reportFileType">
            <el-radio
              :label="file.value"
              v-for="(file, index) in reportFileTypes"
              :key="index"
              >{{ file.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-form>

      <el-button
        class="w-full bg-primary text-white rounded-lg py-4 mt-2"
        @click="openVerifyAuthDialog"
        >Generate Report</el-button
      >
    </el-dialog>

    <verify-auth-dialog
      v-if="showVerifyAuthDialog"
      :authState="authState"
      :showDialog="showVerifyAuthDialog"
      @closeDialog="closeVerifyAuthDialog"
      @generateReport="getTransactionReport"
    />
  </div>
</template>
<style scoped>
#header {
  margin-top: -2.5rem;
}
</style>
